import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  FormGroup,
  ControlLabel,
  HelpBlock,
  FormControl,
  InputGroup,
  Alert,
  DropdownButton,
  MenuItem
} from "react-bootstrap";
import { find, prop, equals, head } from "ramda";
import questionTypes from "../questionTypes.json";
import unitOfMeasure, { getUnitsOfMeasure } from '../common/unitOfMeasure';
const DIVISION = 'division';
const MULTIPLICATION = 'multiplication'

const getAnswerId = prop("answerId");
const findAnswerForOption = option =>
  find(answer => equals(getAnswerId(option), getAnswerId(answer)));

class WeightQuestion extends Component {
  constructor(props) {
    super(props)

    const { readOnly, options, answers } = props
    const option = head(options);

    let displayValue = ''
    let selectedUnitOfMeasure = unitOfMeasure(option)

    if (readOnly) {
      const answer = findAnswerForOption(option)(answers);
      displayValue = answer.meta.displayValue
      selectedUnitOfMeasure = answer.meta.unitOfMeasure
    }

    this.state = {
      selectedUnitOfMeasure,
      displayValue
    }

    this.renderWithUnitsOfMeasure = this.renderWithUnitsOfMeasure.bind(this)
    this.renderWithoutUnitsOfMeasure = this.renderWithoutUnitsOfMeasure.bind(this)
    this.unitOfMeasureSelected = this.unitOfMeasureSelected.bind(this)
  }

  unitOfMeasureSelected(unitOfMeasure) {
    const {
      questionId,
      onAnswer,
      options
    } = this.props

    const option = options[0];
    const value = Number.parseFloat(this.state.displayValue)

    this.setState({ selectedUnitOfMeasure: unitOfMeasure })
    if (!value) {
      return;
    }
    let baseValue = this.convertFromDisplayUnit(value, unitOfMeasure)

    onAnswer(
      questionId,
      questionTypes.weight,
      option.answerId,
      baseValue + '',
      {
        displayValue: this.state.displayValue,
        unitOfMeasure: unitOfMeasure
      }
    )
  }

  convertFromDisplayUnit(value, selectedUnitOfMeasure) {
    const howToConvertToDefault = selectedUnitOfMeasure.conversionToDefault;
    let newValue = value
    if (howToConvertToDefault && howToConvertToDefault.operation === DIVISION) {
      switch (howToConvertToDefault.operation) {
      case DIVISION: {
        newValue = newValue / howToConvertToDefault.by
        break;
      }
      case MULTIPLICATION: {
        newValue = newValue * howToConvertToDefault.by
        break;
      }
      }
    }
    return Number.parseFloat(Number.parseFloat(newValue).toFixed(2));
  }

  convertToDisplayUnit(value, selectedUnitOfMeasure) {
    const howToConvertToDisplayUnit = selectedUnitOfMeasure.conversionFromDefault;
    let newValue = value
    if (howToConvertToDisplayUnit
      && howToConvertToDisplayUnit.operation === DIVISION
      && value !== '') {
      const { by, operation } = howToConvertToDisplayUnit
      switch (operation) {
      case DIVISION:{
        newValue = newValue / by
        break;
      }
      case MULTIPLICATION:{
        newValue = newValue * by
        break;
      }
      }
    }
    return newValue;
  }

  renderWithUnitsOfMeasure(option, value, unitsOfMeasure) {
    const {
      questionId,
      text,
      help,
      onAnswer,
      readOnly,
      validationState
    } = this.props

    return (
      <FormGroup
        controlId={questionId}
        validationState={validationState}
      >
        <ControlLabel>
          {text}
        </ControlLabel>
        <InputGroup className='col-md-3 input-form-group'>
          <FormControl
            type="number"
            onChange={(event) => {
              this.setState({
                displayValue: event.target.value
              })
              const baseValue = this.convertFromDisplayUnit(event.target.value, this.state.selectedUnitOfMeasure);
              onAnswer(
                questionId,
                questionTypes.weight,
                option.answerId,
                baseValue + '',
                {
                  displayValue: event.target.value,
                  unitOfMeasure: this.state.selectedUnitOfMeasure
                }
              )
            }}
            disabled={readOnly}
            placeholder={option.text}
            value={this.state.displayValue}
          />
          { readOnly ? <InputGroup.Addon>{this.state.selectedUnitOfMeasure.unitOfMeasure}</InputGroup.Addon> :
            <DropdownButton id="weightDropDown" componentClass={InputGroup.Button} title={this.state.selectedUnitOfMeasure.unitOfMeasure}>
              { unitsOfMeasure.map(
                (unitOfMeasure) =>
                  <MenuItem
                    id={unitOfMeasure.unitOfMeasure}
                    onSelect={() => this.unitOfMeasureSelected(unitOfMeasure)}
                    key={unitOfMeasure.unitOfMeasure}>
                    {unitOfMeasure.unitOfMeasure}
                  </MenuItem>)
              }
            </DropdownButton>
          }
        </InputGroup>
        {help && <HelpBlock>{help}</HelpBlock>}
      </FormGroup>
    );
  }

  renderWithoutUnitsOfMeasure(option, value) {
    const {
      questionId,
      text,
      help,
      onAnswer,
      readOnly,
      showValidation,
      validationState
    } = this.props

    return (
      <FormGroup className='col-md-3 input-form-group' controlId={questionId} validationState={validationState}>
        <ControlLabel>
          {text}
        </ControlLabel>
        <FormControl
          type="weight"
          disabled={readOnly}
          placeholder={option.text}
          value={value}
          onChange={event =>
            onAnswer(
              questionId,
              questionTypes.weight,
              option.answerId,
              event.target.value
            )}
        />
        {help &&
        showValidation && (
            <HelpBlock>
              <Alert bsStyle="danger">{help}</Alert>
            </HelpBlock>
          )}
      </FormGroup>
    );
  }

  render() {
    const { units, options, answers } = this.props

    const option = options[0];
    const answer = findAnswerForOption(option)(answers);

    const value = answer ? prop("value")(answer) : "";

    if (units) {
      return this.renderWithUnitsOfMeasure(option, value, getUnitsOfMeasure(option));
    }

    return this.renderWithoutUnitsOfMeasure(option, value);
  }
}

WeightQuestion.propTypes = {
  questionId: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  help: PropTypes.string,
  options: PropTypes.array.isRequired,
  answers: PropTypes.array,
  units: PropTypes.array,
  onAnswer: PropTypes.func,
  onUnitsChange: PropTypes.func,
  readOnly: PropTypes.bool,
  showValidation: PropTypes.bool,
  validationState: PropTypes.string,
  value: PropTypes.number
}

export default WeightQuestion;



// WEBPACK FOOTER //
// ./src/components/questions/WeightQuestion/WeightQuestion.js